import React from 'react';
import { Switch, Route } from 'react-router-dom';
import routes from 'src/constants/routes.json';
import Dashboard from 'src/containers/Pages/Dashboard';
import Account from './Pages/Account';
import ChangePassword from './Pages/ChangePassword';
import Order from './Pages/Orders/Details';
import Orders from './Pages/Orders';
import Commissions from './Pages/Commissions';
import Transfers from './Pages/CommissionsTransfers';
import Transfer from './Pages/CommissionsTransfers/Details';
import { PrivateRoute, PublicRoute } from './PrivateRoute';
import Establishment from './Pages/Establishment';
import NewEstablishment from './Pages/Establishments/New';
import EditEstablishment from './Pages/Establishments/Edit';
import Establishments from './Pages/Establishments';
import RequestTerminal from './Pages/Terminals/New';
import EditTerminal from './Pages/Terminals/Edit';
import Terminals from './Pages/Terminals';
import Users from './Pages/Users';
import NewUser from './Pages/Users/New';
import Payments from './Pages/Payments';
import Unicef from './Pages/Unicef';
import ZwalletDashboard from 'src/ZWallet/Dashboard';
import ZwalletOperations from 'src/ZWallet/Operations';
import ZwalletPayment from 'src/ZWallet/Payment/components/Payment';
import ZwalletTransfer from 'src/ZWallet/Transfer/components/Transfer';
import Receipt from './Pages/Receipt';
import Wallet from './Pages/Wallet';
import Items from './Pages/Items';

const Routes = () => (
    <Switch>
        <PrivateRoute path={routes.ACCOUNT} component={Account} />
        <PrivateRoute path={routes.CHANGE_PASSWORD} component={ChangePassword} />
        <PrivateRoute path={routes.ORDER} component={Order} />
        <PrivateRoute path={routes.ORDERS} component={Orders} />
        <PrivateRoute path={routes.COMISSIONS} component={Commissions} />
        <PrivateRoute path={routes.TRANSFERS} component={Transfers} />
        <PrivateRoute path={routes.TRANSFER} component={Transfer} />
        <PrivateRoute path={routes.ITEMS} component={Items} />
        <PrivateRoute path={routes.ESTABLISHMENT} component={Establishment} />
        <PrivateRoute path={routes.NEW_ESTABLISHMENT} component={NewEstablishment} />
        <PrivateRoute path={routes.EDIT_ESTABLISHMENT} component={EditEstablishment} />
        <PrivateRoute path={routes.ESTABLISHMENTS} component={Establishments} />
        <PrivateRoute path={routes.REQUEST_TERMINAL} component={RequestTerminal} />
        <PrivateRoute path={routes.TERM} component = {Receipt} />
        {/* <PrivateRoute path={routes.EDIT_TERMINAL} component={EditTerminal} /> */}
        <PrivateRoute path={routes.TERMINALS} component={Terminals} />
        <PrivateRoute path={routes.NEW_USER} component={NewUser} />
        <PrivateRoute path={routes.USERS} component={Users} />
        <PrivateRoute path={routes.PAYMENTS} component={Payments} />
        <PrivateRoute path={routes.ZWALLET_PAYMENT} component={ZwalletPayment} />
        <PrivateRoute path={routes.ZWALLET_OPERATIONS} component={ZwalletOperations} />
        <PrivateRoute path={routes.ZWALLET_TRANSFER} component={ZwalletTransfer} />
        <PrivateRoute path={routes.ZWALLET_DASHBOARD} component={ZwalletDashboard} />
        <PrivateRoute path={routes.CARTEIRA} component={Wallet} />
        <PublicRoute path={routes.UNICEF} component={Unicef} />
        <PrivateRoute exact path="/*" component={Dashboard} />
    </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js